module.exports = __webpack_public_path__ + "static/img/kyjx.96643ec1.png";